
export const LicenseType = {
  MONETIZED: "MONETIZED",
  NON_MONETIZED: "NON_MONETIZED"
}